module.exports = __webpack_public_path__ + "img/camp_shirt_other4.c14b6556.svg";